module.exports = __webpack_public_path__ + "img/service3.2fb6bd6b.png";